// src/pages/Login.js
import React, { useState } from 'react';
import { useNavigate }       from 'react-router-dom';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth, db }          from '../firebase';
import { doc, getDoc }       from 'firebase/firestore';
import Layout from '../components/Layout';

export default function Login() {
  const [email, setEmail]   = useState('');
  const [password, setPass] = useState('');
  const [error, setError]   = useState('');
  const navigate            = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const cred = await signInWithEmailAndPassword(auth, email, password);
      // Fetch role and then navigate to root (App.js will redirect)
      const snap = await getDoc(doc(db, 'users', cred.user.uid));
      if (!snap.exists()) throw new Error('No user profile found');
      navigate('/');
    } catch (err) {
      setError(err.message);
    }
  };

   return (
       <Layout>
         <div className="flex items-center justify-center min-h-screen bg-gray-100">
           <form className="w-full max-w-sm p-6 bg-white rounded-lg shadow space-y-6" onSubmit={handleSubmit}>
             <div className="bg-[#0047AB] p-3 rounded-md mb-4">
               <h1 className="text-2xl font-bold text-center text-white">Login</h1>
             </div>
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={e => setEmail(e.target.value)}
           className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-[#FF6B00]"
          required
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={e => setPass(e.target.value)}
           className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-[#FF6B00]"
          required
        />
        {error && <p className="text-red-600 text-sm">{error}</p>}
        <button
          type="submit"
          className="w-full py-2 bg-[#FF6B00] text-white rounded-md hover:bg-[#e65c00]"
        >
          Login
        </button>
      </form>

       </div>
   </Layout>
 );
}
